export class Page {
    public numPages:number;
    public pageItems: any[];

    constructor(
        public itemsPerPage: number = 10,
        public currentPage: number = 1,
        public totalItems:number =0,
        public items:any[] = []
    ) {
        this.numPages = Math.ceil(totalItems/itemsPerPage);
        let startItem = this.itemsPerPage*this.currentPage;
        this.pageItems = this.items.slice(startItem-this.itemsPerPage, startItem);
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/pager/page.ts